import { Typography } from '@shared/ui'
import styles from './Navbar.module.scss'
import { navigation } from '@shared/constants/constants'
import { useScroll } from '@shared/hooks/useScroll'
import { useTranslation } from 'react-i18next'

export const Navbar = () => {
  const { scrollToBlock } = useScroll ()
  const { t } = useTranslation()
  return (
    <ul className={styles.navbar}>
      {navigation.map((item) => 
        <li onClick={() => scrollToBlock(item.id)} key={item.id}>
          <Typography 
            variant='h6regular' 
            color='black'
          >
            {t(item.title)}
          </Typography>
        </li>
      )}
    </ul>
  )
}

